import { render } from "./StorySection.vue?vue&type=template&id=0d2edc3e&scoped=true"
import script from "./StorySection.vue?vue&type=script&lang=ts"
export * from "./StorySection.vue?vue&type=script&lang=ts"

import "./StorySection.vue?vue&type=style&index=0&id=0d2edc3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d2edc3e"

export default script